/**
 * Item status checks — what came in with the device. Same row pattern as
 * Damage, but the answers carry no good/bad polarity ("All feet present",
 * "Wobbles", "USB items"), so nothing here colours them.
 */

import React from 'react';

import { ChecklistSection, type ChecklistSectionProps } from './ChecklistSection';

export const ItemStatusSection: React.FC<ChecklistSectionProps> = props => (
  <ChecklistSection hint="Answer each item as it applies to this device." {...props} />
);
